export const CAMPAIGNS = {
  path: 'campaigns',
  redirect: { name: 'campaigns' },
  children: [
    {
      path: '',
      name: 'campaigns',
      meta: {
        title: 'campaigns.meta.title',
        permissions: ['campaign_r']
      },
      component: () => import('@/views/recruiter/CampaignsTableView.vue')
    },
    {
      path: 'create',
      name: 'create-campaign',
      meta: {
        title: 'campaigns.meta.title',
        permissions: ['campaign_w']
      },
      component: () => import('@/views/recruiter/CampaignStepperView.vue')
    },
    {
      path: ':uuid/edit',
      name: 'edit-campaign',
      meta: {
        title: 'campaigns.meta.title',
        permissions: ['campaign_w']
      },
      component: () => import('@/views/recruiter/CampaignStepperView.vue')
    },
    {
      path: ':uuid/add_contacts',
      name: 'add-users-campaign',
      meta: {
        title: 'campaigns.meta.title',
        permissions: ['campaign_r']
      },
      component: () => import('@/views/recruiter/AddUserCampaignView.vue')
    },
    {
      path: ':uuid',
      name: 'view-campaign',
      meta: {
        title: 'campaigns.meta.title',
        permissions: ['campaign_r']
      },
      component: () => import('@/views/recruiter/CampaignView.vue')
    }
  ]
};
